/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:22:35
 * @Description:
 */

import config from "@/config";

/**
 * 更新页面 title 守卫
 * @typedef afterGuard
 */
export function updateTitleGuard(to, from) {
	const title = (to.meta && to.meta.title) || "";
	// 设置页面标题为 "路由标题 | 项目名称"
	// document.title = title ? `${title} | ${config.ENVS.PROJECT_NAME}` : config.ENVS.PROJECT_NAME
	document.title = title ? `${title}` : "统一身份认证平台";
}
